import React from 'react'
import { useTranslation } from 'react-i18next'

export default function StudentCountLabel({ count, id }) {
    const { t, i18n } = useTranslation()
    if (!Number.isInteger(count)) return null
    return (
        <span id={id} className="text-[14px] leading-5 font-medium text-[#9998AE] whitespace-nowrap shrink-0">
            {t('studentCountLabel', { count, total: new Intl.NumberFormat(i18n?.language).format(count) })}
        </span>
    )
}
